/**
 * Copyright (c) 2018 Microsoft Corporation
 */
import {
  getPayloadObject,
  getTelemetryAttributes,
  IPayLoad,
} from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import {
  Dropdown as CittaDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from '../../../components/citta-dropdown/index';
import RichSelect from '../rich-select/RichSelect';
import { IRichSelectOnChangeNotification } from '../rich-select/RichSelect.props';
import { IDropdownProps } from './';
import { IDropdownItemProps } from './dropdown.props';

type IDropdownState = {
  /**
   * @friendlyName selectedIndex
   * @description selected index
   */
  selectedIndex: string;
};

/**
 *
 * DropDown component
 * @extends {React.PureComponent<IDropdownProps, IDropdownState>}
 */
export class Dropdown extends React.PureComponent<
  IDropdownProps,
  IDropdownState
> {
  private selectMenu: React.RefObject<HTMLSelectElement> = React.createRef<
    HTMLSelectElement
  >();
  private payLoad: IPayLoad;

  constructor(props: IDropdownProps, state: IDropdownState) {
    super(props);
    this.state = {
      selectedIndex: '',
    };
    this.payLoad = getPayloadObject(
      'click',
      props.telemetryContent!,
      this.props.dropdownName
    );
  }

  public componentDidMount(): void {
    if (this.selectMenu.current) {
      this.selectMenu.current.selectedIndex = 0;
    }
  }

  public render(): JSX.Element {
    const {
      dropdownId,
      dropdownList,
      dropdownName,
      dropdownToggleName,
    } = this.props;
    const attribute = getTelemetryAttributes(
      this.props.telemetryContent!,
      this.payLoad
    );
    return (
      // @ts-ignore
      <RichSelect
        aria-label={dropdownName}
        {...attribute}
        className='msc-dropdown__select'
        id={`product-configure-${dropdownId}`}
        onChange={this._onChanged}
      >
        <CittaDropdown>
          <DropdownToggle
            caret
            className='bg-white text-dark'
            disabled={dropdownList.length === 0}
          >
            {dropdownToggleName}
          </DropdownToggle>
          <DropdownMenu>
            {dropdownList.map(
              (item: IDropdownItemProps) =>
                item && (
                  <DropdownItem id={item.id} key={item.id}>
                    {item.value}
                  </DropdownItem>
                )
            )}
          </DropdownMenu>
        </CittaDropdown>
      </RichSelect>
    );
  }
  private _onChanged = async (
    notification: IRichSelectOnChangeNotification
  ) => {
    this.setState({
      selectedIndex:
        notification.selectedItems.length > 0
          ? notification.selectedItems[0].id
          : '',
    });
    if (this.props.onChange) {
      await this.props.onChange({
        dropdownId: this.props.dropdownId,
        selectId:
          notification.selectedItems.length > 0
            ? notification.selectedItems[0].id
            : '',
        selectedValue:
          notification.selectedItems.length > 0
            ? notification.selectedItems[0].value
            : '',
      });
    }
  };
}
